import React from 'react';
import whatBg from '../../../assets/site/bg-invest.jpg';
import Section from '../../site/components/Section';
import SectionHead from '../../site/components/SectionHead';
import { investmentOptions } from '../../site/data/content';
import ui from '../../site/styles/primitives.module.css';
import { whatWeDo } from '../aboutContent';
import PillarGrid from '../components/PillarGrid';
import styles from './WhatWeDo.module.css';

const WhatWeDo = () => (
  <Section id="what" background={whatBg} backgroundPosition="center 55%">
    <div className={ui.wrap}>
      <SectionHead
        eyebrow="What DS360 Investment is"
        title="A real estate investment company"
        highlight="built around you"
        lede={whatWeDo}
      />
      <PillarGrid items={investmentOptions} />
      <p className={styles.note} data-reveal="">
        <b>EB-5 opportunities.</b> Our opportunities also include EB-5 investments, such as a residential development
        in Newark, NJ.
      </p>
    </div>
  </Section>
);

export default WhatWeDo;
